/** Client-only: Filter für Objekt-Hub Messprotokoll-Liste (kein Server-Import). */
export function filterRelevantMessprotokollHubRows(rows = []) {
  return (Array.isArray(rows) ? rows : []).filter(
    (row) => row?.has_protocol || row?.expects_protocol
  );
}
